import { Typography } from '../../../../shared/ui/typography/typography';
import { COLORS } from '../../../../shared/config/colors/colors';
import { styled } from 'goober';
import { productDescriptiobQuillStyle } from '@shared/style/product-description-quill-style';

export const Wrapper = styled('div')`
    display: flex;
    padding: 20px;
    border-radius: 20px;
    flex-direction: column;
    gap: 20px;
    background-color: ${COLORS.neutral_00};
`;

export const Title = styled(Typography)`
    margin-top: 20px;
`;

export const Paragraph = styled(Typography)`
    margin-top: 12px;
`;

export const Location = styled('div')`
    display: flex;
    align-items: center;
    gap: 8px;
    margin-top: 12px;
`;

export const Description = styled('div')`
    padding: 0;
    ${productDescriptiobQuillStyle}
`;
